import mutations from './analytics.event-listener';

export default {
  mutations,
};



// WEBPACK FOOTER //
// ./src/app/features/analytics/analytics.store.js